import React from "react";
import { string } from "prop-types";

import { useUIBehavior } from "../../redux/hooks/uiHooks";
import SellerLandingCTA from "../SellerLandingCTA";
import * as S from "./styled";

const MessageSent = ({
  agentName,
  ariaContentDescribedBy,
  ariaContentLabelledBy,
  className
}) => {
  const { closeExpertMatchDrawer } = useUIBehavior();

  return (
    <div className={className} data-qa="seller-inquiry-success-modal">
      <S.SuccessMessageContainer>
        <S.CheckMarkContainer>
          <S.CheckMark />
        </S.CheckMarkContainer>
        <S.SuccessTitle id={ariaContentLabelledBy}>
          Message Sent!
        </S.SuccessTitle>
        <S.SuccessTextContainer>
          <S.SuccessText id={ariaContentDescribedBy}>
            You&apos;ll hear from {agentName} shortly.
          </S.SuccessText>
        </S.SuccessTextContainer>
      </S.SuccessMessageContainer>
      <S.CTAContainer>
        <SellerLandingCTA
          handleCloseClick={closeExpertMatchDrawer}
          href="/sell-your-home"
        />
      </S.CTAContainer>
    </div>
  );
};

MessageSent.propTypes = {
  agentName: string.isRequired,
  ariaContentDescribedBy: string,
  ariaContentLabelledBy: string,
  className: string
};

MessageSent.defaultProps = {
  ariaContentLabelledBy: null,
  ariaContentDescribedBy: null,
  className: ""
};

export default MessageSent;
